import { InfoLeagueProps } from '../leagues.props';
import { Alexandrite } from './Alexandrite';

export const AlexandriteLeague: InfoLeagueProps = {
  id: `${process.env.REACT_APP_ID_LEAGUE_ALEXANDRITE}`,
  icon: '🟢',
  name: 'Alejandrita',
  description: 'La gema cambiante. Solo para maestros estrategas.',
  active: false,
  color: '#FFFFFF',
  bgColor: '#2E8B57',
  borderColor: '#2E8B57',
  path: '/alexandrite',
  page: Alexandrite,
};
